<script>
  import { accountBottomNav } from '../sections/account-support.js';
</script>

<nav class="bottom-nav" aria-label={accountBottomNav.ariaLabel}>
  <div class="bottom-nav-inner">
    {#each accountBottomNav.items as item}
      <a href={item.href} class:active={item.active}>{item.label}</a>
    {/each}
  </div>
</nav>

<style>
  /* Виден только на мобайле — desktop / tablet прячут */
  .bottom-nav {
    display: none;
  }

  @media (max-width: 767px) {
    .bottom-nav {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 40;
      display: block;
      padding: 8px 12px;
      padding-bottom: max(8px, env(safe-area-inset-bottom));
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(0, 0, 0, 0.9);
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
    }

    .bottom-nav-inner {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 4px;
      max-width: 520px;
      margin: 0 auto;
      text-align: center;
    }

    .bottom-nav a {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 8px 8px;
      border-radius: 12px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 11px;
      font-weight: 500;
      text-decoration: none;
      transition: color 160ms ease;
    }

    .bottom-nav a.active {
      color: #e7b962;
    }

    .bottom-nav a:hover,
    .bottom-nav a:focus-visible {
      color: #ffffff;
    }

    .bottom-nav a.active:hover,
    .bottom-nav a.active:focus-visible {
      color: #ffa800;
    }
  }
</style>
